export default {
  resource:{
    zh: {
      title:"账户",
      empId: "工号",
      empName: "姓名",
      icNo: "IC卡号",
      cardDate: "发卡时间",
      status: "状态",
      status1: "正常",
      status0: "禁用",
      money: "余额",
      enable:"启用",
      disable:"禁用",
      nullId:"部门序号不能为空！",
      nullName:"部门名称不能为空！",
      alExists:"部门序号或名称已经存在，请检查！",
      nameExist:"部门已经存在，请检查！"
    }
  },
  params: {
    empId:{
      key: "empId",
      data: null,
      method: "Equal",
      type: "number"
    },
    empName:{
      key: "empName",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "empId","empName","icNo", {key:"cardDate", formatter:"fdateTime", width:180}, {key:"status", formatter:"fstatus"}, "money"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"empId",
  defaultSortOrder:"asc",
  sortName: "empId",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "empAccount/",
  autoId: "autoid",
  formatter: {
    fstatus(v){
      return "status" + v
    }
  }

}
